export var __useDefault = true; export default "<div class=\"Card-heading\">\n    <%- T_('选择国家网站') %>\n</div>\n";